<template>
  <div class="v2-phone-input-wrapper">
    <label
      v-if="label"
      class="v2-phone-input__label"
    >{{ label }}</label>
    <vue-tel-input
      class="v2-phone-input"
      :class="{ 'v2-phone-input--disabled': disabled, 'v2-phone-input--error': error }"
      :value="value"
      :input-options="inputOptions"
      :disabled="disabled"
      mode="international"
      v-on="$listeners"
      @input="(number, phoneObj) => $emit('phone-input', number, phoneObj)"
    />
    <small
      v-if="error"
      class="v2-phone-input__error"
    >{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: 'V2PhoneInput',
  props: {
    value: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    error: { type: String, default: '' },
    label: { type: String, default: '' },
    inputOptions: {
      type: Object,
      default: () => ({ id: 'phone-input', placeholder: 'Enter phone number' }),
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-phone-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--v2-space-1);
}

.v2-phone-input__label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--v2-foreground);
}

.v2-phone-input__error {
  font-size: 0.75rem;
  color: var(--v2-destructive);
}
</style>

<style lang="scss">
/* Trigger — translucent fill, no `backdrop-filter`. Matches V2Input recipe. */
.v2-phone-input.vue-tel-input {
  background: var(--v2-glass-surface-2);
  border: 1px solid var(--v2-glass-stroke);
  border-radius: var(--v2-radius-md);
  font-family: var(--v2-font-sans);
  font-size: 0.875rem;
  min-height: 38px;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: var(--v2-primary);
    box-shadow: 0 0 0 3px oklch(0.62 0.21 295 / 0.25);
  }

  .vti__input {
    color: var(--v2-foreground);
    background: transparent;
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;

    &::placeholder {
      color: var(--v2-muted-foreground);
    }
  }

  .vti__dropdown {
    background: transparent;
    border-right: 1px solid var(--v2-glass-stroke);
    border-radius: var(--v2-radius-md) 0 0 var(--v2-radius-md);
  }
}

.v2-phone-input--disabled.vue-tel-input {
  opacity: 0.6;
  cursor: not-allowed;
  background: var(--v2-muted);

  .vti__dropdown {
    cursor: not-allowed;
  }
}

.v2-phone-input--error.vue-tel-input {
  border-color: var(--v2-destructive);
}
</style>
